import { createSelector } from "reselect";

// Selectors
import { createCurrentPageEventsForRevisionIdQuerySelector } from "src/selectors/query_selectors/events_for_revision_id";

/**
 * create a selector to get the context for the current page - loading events with a revisionId
 * @param {Object} props
 * @param {string} props.revisionId
 * @returns {function} selector
 */
export function createCurrentPageEventsForRevisionIdContextSelector({
  revisionId
}) {
  return createSelector(
    createCurrentPageEventsForRevisionIdQuerySelector({ revisionId }),
    query => {
      return query;
    }
  );
}
